import get from 'lodash.get';

const getDialogVisibility = (state) =>
  get(state, 'ws.integration.settings.ui.isDialogVisible', false);

export default getDialogVisibility;
